<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style lang="stylus">
html
  background-color: #F5F5F9;
  margin: 0;
  padding: 0
</style>

<script>
import VuexCommonMix from '@/store/vuexCommonMix'
export default {
  name: 'app',
  mixins: [VuexCommonMix],
  data () {
    return {}
  },
  created () {
  },
  destroyed () {},
  methods: {}
}
</script>
